import { render, staticRenderFns } from "./my-card-template.vue?vue&type=template&id=c3c0c9f8&scoped=true&lang=pug&"
import script from "./my-card-template.vue?vue&type=script&lang=js&"
export * from "./my-card-template.vue?vue&type=script&lang=js&"
import style0 from "./my-card-template.vue?vue&type=style&index=0&id=c3c0c9f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c0c9f8",
  null
  
)

export default component.exports